import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { CepPipe } from './cep.pipe'
import { CpfCnpjPipe } from './cpf-cnpj.pipe'
import { TelefonePipe } from './telefone.pipe';
import { SearchFilterPipe } from './search-filter.pipe';
import { SearchFilterVehiclePipe } from './search-filter-vehicle.pipe';
import { ChargeFilterPipe } from './charge-filter.pipe'

import { DateBrPipe } from './convert-date-br.pipe';
import { NameFormatPipe } from './nameFormat';
import { HighlightLettersPipe } from './highlight-letters.pipe';
import { FilterItemsPipe } from './filter-text.pipe';
import { TimezoneAdjustPipe } from './timezone-adjust.pipe'
import { PlacaFormatPipe } from './placa-format.pipe'
import { VehicleTypePipe } from './vehicle-type.pipe';

@NgModule({

  declarations: [HighlightLettersPipe, CepPipe, CpfCnpjPipe, TelefonePipe, SearchFilterPipe, SearchFilterVehiclePipe, ChargeFilterPipe, DateBrPipe,NameFormatPipe, FilterItemsPipe, TimezoneAdjustPipe, PlacaFormatPipe, VehicleTypePipe],
  imports: [CommonModule],
    exports: [HighlightLettersPipe, CepPipe, CpfCnpjPipe, TelefonePipe, SearchFilterPipe, SearchFilterVehiclePipe, ChargeFilterPipe, DateBrPipe,NameFormatPipe, FilterItemsPipe, TimezoneAdjustPipe, PlacaFormatPipe, VehicleTypePipe],
  providers: [CepPipe, CpfCnpjPipe, TelefonePipe, HighlightLettersPipe, FilterItemsPipe, PlacaFormatPipe]
})
export class PipesModule {}
